module.exports = "<!-- Header -->\n<header id=\"head\">\n    <div class=\"container\">\n        <div class=\"row\">\n            <p style=\"margin-bottom: 15px;\"><a class=\"btn btn-lg\" role=\"button\" style=\"color:white; background-color:rgb(31, 112, 191);\" routerLink=\"/fe\"> CREER UN DOSSIER</a>\n                <a class=\"btn btn-action btn-lg\" role=\"button\" routerLink=\"/searchAdvanced\">RECHERCHER UN DOSSIER</a></p>\n        </div>\n    </div>\n</header>\n<!-- /Header -->"


//////////////////
// WEBPACK FOOTER
// ./src/app/header/header.component.html
// module id = ./src/app/header/header.component.html
// module chunks = main